// Variables are set in .env
export const apiHost = process.env.LIFESUM_API_HOST
export const wordpressApiHost = process.env.WORDPRESS_API_HOST
export const gaTrackingId = process.env.GOOGLE_ANALYTICS_ID
export const facebookLoginAppId = process.env.FACEBOOK_LOGIN_APP_ID
export const adyenOriginKey = process.env.ADYEN_ORIGIN_KEY
export const environment = process.env.environment
export const appleRedirectUri = process.env.APPLE_REDIRECT_URI
